import { ref } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b22c0742"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "filter-list-content"
};
const _hoisted_3 = {
  class: "input-select-content"
};
const _hoisted_4 = {
  class: "filter-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "产品名", -1));
const _hoisted_6 = {
  class: "appListPopover-content"
};
const _hoisted_7 = {
  class: "appListPopover-content-title"
};
const _hoisted_8 = {
  class: "inf-label"
};
const _hoisted_9 = {
  class: "inf-value"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_11 = {
  class: "filter-list"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "设备ID", -1));
const _hoisted_13 = {
  class: "btn-content"
};
import { onMounted } from '@vue/runtime-core';
import { detailFields, searchFields, getAppListInformation, copy } from '@/common';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import { queryGoodsOption } from '@/api/goodsSetting';
export default /*#__PURE__*/_defineComponent({
  __name: 'PropsFilterBlock',
  emits: ['filterSubmit'],
  setup(__props, {
    emit
  }) {
    const dbtId = ref(null); // 产品名
    const deviceId = ref(''); // 设备id
    const dbtProducts = ref([]); // app列表
    const productSelectRef = ref(null);
    const filterSubmit = () => {
      const params = {
        dbtId: dbtId.value,
        deviceId: deviceId.value
      };
      emit('filterSubmit', params);
    }; // 搜索
    const init = () => {
      if (dbtProducts.value.length) {
        dbtId.value = dbtProducts.value[0].value;
      }
      deviceId.value = '';
      filterSubmit();
    }; // 初始化
    const getAppData = async () => {
      try {
        const {
          code,
          data
        } = await queryGoodsOption();
        if (code === '0') {
          var _productSelectRef$val;
          dbtProducts.value = data.map(item => {
            var _item$extData;
            return {
              ...item,
              label: item.appName,
              value: item.dbtId,
              ...item.extData,
              filePath: ((_item$extData = item.extData) === null || _item$extData === void 0 ? void 0 : _item$extData.filePath) || '-'
            };
          });
          (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(dbtProducts.value);
        }
      } catch (e) {}
    }; // 获取产品列表
    onMounted(async () => {
      await getAppData();
      init();
    });
    return (_ctx, _cache) => {
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_unref(ProductSelect), {
        ref_key: "productSelectRef",
        ref: productSelectRef,
        modelValue: dbtId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dbtId.value = $event),
        multiple: false,
        "show-extra": true,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": true,
        layout: "vertical",
        descriptionField: "filePath",
        width: 200,
        "popup-class-name": "vertical-product-select",
        placeholder: "请选择",
        detailFields: _unref(detailFields),
        onChange: filterSubmit,
        "show-bottom-border": ""
      }, {
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_8, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_9, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_10]),
            default: _withCtx(() => [_createVNode(_component_SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue", "search-fields", "detailFields"])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_a_input, {
        placeholder: "请输入设备ID",
        value: deviceId.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => deviceId.value = $event),
        valueModifiers: {
          trim: true
        }
      }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_button, {
        onClick: init
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});